require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/error.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/error.legacy.js
// module id = 618
// module chunks = 31